
import React from 'react';
import Button from '../../../components/base/Button';

export default function EducationSection() {
  const educationCards = [
    {
      icon: 'ri-book-2-line',
      title: 'Books & Publications',
      description: 'Comprehensive guides on oxygen health, deficiency prevention, and wellness strategies.',
      features: ['Research-backed content', 'Easy-to-understand language', 'Practical tips'],
      image: 'https://public.readdy.ai/ai/img_res/a452fd9a255a6cadcc12d44b20d89774.jpg'
    },
    {
      icon: 'ri-video-line',
      title: 'Newsletters & Reels',
      description: 'Regular updates, health tips, and engaging video content to keep you informed.',
      features: ['Weekly newsletters', 'Educational reels', 'Expert interviews'],
      image: 'https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/67c219b35f530b4d32cea9fc4e3f63eb.jfif'
    },
    {
      icon: 'ri-team-line',
      title: 'Community Programs',
      description: 'Interactive workshops and community outreach programs in local communities.',
      features: ['Local workshops', 'Community screenings', 'Health awareness camps'],
      image: 'https://readdy.ai/api/search-image?query=Community%20health%20workshop%20with%20diverse%20people%20learning%20about%20oxygen%20therapy%20in%20bright%20educational%20setting%2C%20healthcare%20professionals%20teaching%20breathing%20techniques%20to%20engaged%20community%20members%2C%20outreach%20program%20with%20medical%20equipment%20and%20educational%20materials&width=300&height=200&seq=community-workshop-v2&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            Awareness Saves Lives
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            Education is the foundation of prevention. Our comprehensive educational 
            initiatives empower individuals and communities with knowledge about oxygen health.
          </p>
        </div>

        {/* Education Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {educationCards.map((card, index) => (
            <div 
              key={index}
              className="group bg-[#FAFAFA] rounded-3xl overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img 
                  src={card.image} 
                  alt={card.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#12B6B6]/10">
                    <i className={`${card.icon} text-2xl text-[#12B6B6]`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#111111]">{card.title}</h3>
                </div>

                <p className="text-gray-600 mb-6 leading-relaxed">{card.description}</p>

                {/* Features */}
                <ul className="space-y-2">
                  {card.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-2 text-sm text-gray-600">
                      <i className="ri-check-line w-4 h-4 flex items-center justify-center text-[#12B6B6]"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button variant="primary" size="lg">
            Explore Education Initiatives
          </Button>
        </div>
      </div>
    </section>
  );
}
